import { LoginService } from './../../../services/login.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { ReportingService } from '../../../services/reporting.service';
import { ConfigService } from '../../../services/config.service';
import { ReportProcess } from '../../../models/reporting/report-process.model';

@Component({
    selector: 'app-my-reports',
    templateUrl: './my-reports.component.html',
    styleUrls: ['./my-reports.component.scss']
})
export class MyReportsComponent implements OnInit {
    personId: number;
    teammateEmployeeId: string;
    requirementType: string;
    isnoEvaluate = false;
    isviewReport = true;
    completedProcesses$: Observable<Array<ReportProcess>>;

    private isMyTeamPage: boolean;
    constructor(
        private readonly router: Router,
        private readonly configService: ConfigService,
        private readonly reportingService: ReportingService,
        private readonly route: ActivatedRoute,
        private readonly loginService: LoginService
    ) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            this.isMyTeamPage =  params.has('teammatePersonId');
            this.personId = this.isMyTeamPage 
                ? +params.get('teammatePersonId') 
                : this.loginService.getUser.personId;
            this.requirementType = params.get('requirementType');
            this.teammateEmployeeId = params.get('teammateEmployeeId');
            this.completedProcesses$ = this.reportingService.getUserReports(this.personId);
        });
    }

    redirectToInidvidualReport(processId): void {
        if (this.isMyTeamPage) {
            this.router.navigate([`user/my-team/reports/report/${processId}/${this.personId}`, 
            { requirementType: this.requirementType, teammatePersonId: this.personId,
                 teammateEmployeeId: this.teammateEmployeeId, isMyTeamSurveyTab: false}]);
        } else {
             this.router.navigate([`/user/my-page/reports/report/${processId}/${this.personId}`]);
        }
       
     }
}
